import React, { Fragment, useEffect, useState } from 'react';
import DashboardHeader from '../Common/DashboardHeader';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AcceptedData, AcceptedDataApi, ExportDataApi, MailSent, MailSentApi, PendingDataApi, ResendEmailApi } from '../../services/redux/ApiActions';
import { setAcceptedData } from '../../services/redux/AcceptedReducer';
import { setMailSentData } from '../../services/redux/MailSentReducer';
import { setPendingData } from '../../services/redux/PendingReducer';
import { setFiltersData } from '../../services/redux/FilterReducer';
import { Popover, Transition } from '@headlessui/react';
import CustomerInput from '../reusableComponents/CustomerInput';
import FilterEmailInput from '../reusableComponents/FilterEmailInput';
import FilterPhoneInput from '../reusableComponents/FilterPhoneInput';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const Pending = () => {
    const pendingData = useSelector((state) => state.pending.PendingData);
    const acceptedData = useSelector((state) => state.accepted.AcceptedData);
    const loginData = useSelector((state) => state.login.loginData);
    const savedfilterData = useSelector((state) => state.filterData.FiltersData);
    const [filterCustomerName, setFilterCustomerName] = useState('');
    const [filterCustomerPhone, setFilterCustomerPhone] = useState('');
    const [filterCustomerEmail, setFilterCustomerEmail] = useState('');
    const storedtotalRecords = localStorage.getItem('pendingRecordsValue');
    const [v2pRM, setV2pRm] = useState()
    const [partnerBank, setPartnerBank] = useState()
    const [program, setProgram] = useState()
    const [selectedPrograms, setSelectedPrograms] = useState()
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedValueID, setSelectedValueID] = useState(1);
    const [selectedBank, setSelectedBank] = useState('');
    const [selectedBankID, setSelectedBankID] = useState(1);
    const [customerId, setCustomerId] = useState(0);
    const [hdfcRM, setHDFCRM] = useState('');
    const [OBCustomerName, setOBCustomerName] = useState('');
    const [OBCustomerEmail, setOBCustomerEmail] = useState('');
    const [OBCustomerPhone, setOBCustomerPhone] = useState('');
    const [OBCustomerHDFCRM, setOBCustomerHDFCRM] = useState();
    const [selectedItem, setSelectedItem] = useState(null);
    const [changeEmail, setChangeEmail] = useState('');
    const [changePhone, setChangePhone] = useState('');
    const userAgent = window.navigator.userAgent;

    const [currentPage, setCurrentPage] = useState(
        pendingData?.result.pagedInfo?.pageNumber || 1
    );

    const pageSize = 10;
    const totalRecords = pendingData?.result.pagedInfo?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const displayedData = pendingData?.result.value.slice(startIndex, endIndex);
    const ResendEmail = async (id) => {
        // console.log(userAgent)
        const resendEmailPayload = {
            "customerId": id,
            "createdAt": new Date(),
            "createdBy": loginData.userId,
            "createdIp": "",
            "createdUserAgent": userAgent
        }
        // console.log(resendEmailPayload)
        const data = await dispatch(ResendEmailApi(resendEmailPayload, loginData.token_chr));

    }
    const getPageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(
                <li key={i} className={currentPage === i ? 'active' : ''}>
                    <a
                        href="#"
                        className="v2pPagination"
                        rel="customerList"
                        onClick={() => handlePageClick(i)}
                    >
                        {i}
                    </a>
                </li>
            );
        }
        return pageNumbers;
    };
    const handleNextClick = () => {
        // Check if the next button is disabled before proceeding
        if (currentPage < totalPages) {
            handlePageClick(currentPage + 1);
        }
    };
    const handlePageClick = async (pageNumber) => {
        // You should dispatch an action to fetch data for the selected page
        // For now, let's just update the current page in the component state    const mailSentPayload = {

        // const mailSentPayload = {
        //   "filter": "",
        //   "orderBy": "",
        //   "pageSize": 100,
        //   "pageNumber": pageNumber,
        // }
        // const paginatedResponse = await dispatch(MailSentApi(mailSentPayload, loginData.token_chr))
        // if (paginatedResponse) {
        //   dispatch(setMailSentData(paginatedResponse))
        // }
        setCurrentPage(pageNumber);
    };

    const getStartingSerialNumber = () => {
        // Calculate the starting serial number for the current page
        return (currentPage - 1) * pageSize + 1;
    };

    // useEffect(() => {
    //     console.log('mailSent', loginData)
    //     if (pendingData) {
    //         pendingDataCall();
    //     }
    // }, [])
    const pendingDataCall = async () => {
        const pendingDataPayload = {
            "filter": "",
            "orderBy": "",
            "pageSize": storedtotalRecords,
            "pageNumber": 1
        }
        const pendindDataResponse = await dispatch(PendingDataApi(pendingDataPayload, loginData.token_chr))
        if (pendindDataResponse) {
            dispatch(setPendingData(pendindDataResponse))
        }

    }

    const dispatch = useDispatch();
    const navigate = useNavigate()
    const AcceptedApi = async (event) => {
        const acceptedDataApiPayload = {
            "filter": "",
            "orderBy": "",
            "pageSize": 100,
            "pageNumber": 1
        }
        const data = await dispatch(AcceptedDataApi(acceptedDataApiPayload, loginData.token_chr));
        if (data) {
            dispatch(setAcceptedData(data))
            localStorage.setItem('acceptedRecordsValue', data.pagedInfo.totalRecords);
            navigate('/accepted');
        }
    }
    const handleChangeNameFilter = (e) => {
        setFilterCustomerName(e.target.value)
    };

    const handleChangePhoneFilter = (e) => {
        setFilterCustomerPhone(e.target.value)
    };
    const handleChangeEmailFilter = (e) => {
        setFilterCustomerEmail(e.target.value)
    };
    const ApplyFilter = async (event) => {
        event.preventDefault();
        const filterPayload = {
            "filter": `${filterCustomerName !== '' ? `customerName@=${filterCustomerName},` : ''}${filterCustomerEmail !== '' ? `email@=${filterCustomerEmail},` : ''}${filterCustomerPhone !== '' ? `phone@=${filterCustomerPhone}` : ''}`.replace(/,\s*$/, ''),
            "orderBy": "",
            "pageSize": pendingData.result.pagedInfo.totalRecords === 0 ? storedtotalRecords : pendingData.result.pagedInfo.totalRecords,
            "pageNumber": 1
        }
        // console.log(filterPayload)
        const data = await dispatch(PendingDataApi(filterPayload, loginData.token_chr));
        if (data) {
            dispatch(setPendingData(data))
            dispatch(setFiltersData(filterPayload))
        }
    }
    const ClearFilter = async (event) => {

        event.preventDefault();
        setFilterCustomerName('')
        setFilterCustomerPhone('')
        setFilterCustomerEmail('')
        const filterPayload = {
            "filter": ``,
            "orderBy": "",
            "pageSize": storedtotalRecords,
            "pageNumber": 1
        }
        // console.log(filterPayload)
        const data = await dispatch(PendingDataApi(filterPayload, loginData.token_chr));
        if (data) {
            dispatch(setPendingData(data))
        }
    }
    const MailSentCall = async () => {
        navigate('/mailSent')
        dispatch(setFiltersData(''))
    }
    const ExportData = async (event) => {
        event.preventDefault();
        const filterPayload = {
            "filter": savedfilterData.filter,
            "orderBy": '',
            "type": 'pending'
        }
        console.log(filterPayload)
        const data = await dispatch(ExportDataApi(filterPayload, loginData.token_chr));
        if (data) {
            // console.log(data)
            // Decode base64 string to binary data
            const binaryData = atob(data.value);

            // Create a Blob from the binary data
            const arrayBuffer = new ArrayBuffer(binaryData.length);
            const uint8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < binaryData.length; i++) {
                uint8Array[i] = binaryData.charCodeAt(i);
            }

            const blob = new Blob([uint8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            // Generate a random filename
            const randomFileName = `excel_file_${Date.now()}.xlsx`;

            // Create a download link
            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = randomFileName;

            // Trigger a click event on the link to initiate the download
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

            // dispatch(setMailSentData(data))
        }
    }

    const ViewDetails = (items) => {
        // console.log(items)
        // Convert the items object to a query string
        navigate('/details', { state: { item: items } });
    }
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
    const [isRMModalOpen, setIsRMModalOpen] = useState(false);
    const openEditModal = (item) => {
        setIsProfileModalOpen(true);
        setSelectedItem(item);
        // console.log(item)
        setCustomerId(item.id)
        setChangeEmail(item?.email || '');
        setChangePhone(item?.phone || '');
    };

    const openEditV2PRMModal = (item) => {
        const selected = v2pRM?.value.find(data => data?.id === item.v2PRM);
        setIsRMModalOpen(true);
        setSelectedValue(selected.email);
        setCustomerId(item.id);
        setHDFCRM(item.hdfcrm);
        // console.log(item);
    };
    return (
        <>
            <div>
                <div className="grid mt-5 grid-cols-12 gap-4 mb-5">
                    <div className="col-span-12 sm:col-6 md:col-span-6 lg:col-span-3">
                        <label for="email" className="block text-md font-medium leading-6 text-gray-900">Customer</label>
                        <CustomerInput onChange={handleChangeNameFilter} value={filterCustomerName || ""} />
                    </div>
                    <div className="col-span-12 sm:col-6 md:col-span-6 lg:col-span-3 ">
                        <label for="email" className="block text-md font-medium leading-6 text-gray-900">Email</label>
                        <FilterEmailInput onChange={handleChangeEmailFilter} value={filterCustomerEmail} />
                    </div>
                    <div className="col-span-10 sm:col-5 md:col-span-6 lg:col-span-3">
                        <label for="email" className="block text-md font-medium leading-6 text-gray-900">Phone</label>
                        <FilterPhoneInput onChange={handleChangePhoneFilter}
                            className="mobile"
                            value={filterCustomerPhone} />
                    </div>
                    <div className="col-span-2 md:col-span-3 lg:col-span-3 ">
                        <div className="flex mt-10">
                            <Popover className="relative">
                                <Popover.Button className="flex items-center gap-x-1 text-sm font-semibold border-none outline-none leading-6 text-gray-900">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                                        <path fillRule="evenodd" d="M3.792 2.938A49.069 49.069 0 0 1 12 2.25c2.797 0 5.54.236 8.209.688a1.857 1.857 0 0 1 1.541 1.836v1.044a3 3 0 0 1-.879 2.121l-6.182 6.182a1.5 1.5 0 0 0-.439 1.061v2.927a3 3 0 0 1-1.658 2.684l-1.757.878A.75.75 0 0 1 9.75 21v-5.818a1.5 1.5 0 0 0-.44-1.06L3.13 7.938a3 3 0 0 1-.879-2.121V4.774c0-.897.64-1.683 1.542-1.836Z" clipRule="evenodd" />
                                    </svg>
                                    <ChevronDownIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
                                </Popover.Button>

                                <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-200"
                                    enterFrom="opacity-0 translate-y-1"
                                    enterTo="opacity-100 translate-y-0"
                                    leave="transition ease-in duration-150"
                                    leaveFrom="opacity-100 translate-y-0"
                                    leaveTo="opacity-0 translate-y-1"
                                >
                                    <Popover.Panel className="absolute right-10 md:-right-10 sm:top xs:top top-full z-10 mt-3 w-max overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5">
                                        <div onClick={ApplyFilter} className="p-4 hover:cursor-pointer hover:bg-slate-100">Apply Filter</div>
                                        <div onClick={ClearFilter} className="border-t border-gray-200 p-4 hover:cursor-pointer hover:bg-slate-100">Clear Filter</div>
                                    </Popover.Panel>
                                </Transition>
                            </Popover>
                        </div>
                    </div>

                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Sr. No.
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Customer
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Email
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Phone
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Partner Bank
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Program
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Date
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {displayedData?.map((item, index) => (
                                <tr key={index} className="border-t">
                                    <td className="px-6 py-4 whitespace-nowrap">{getStartingSerialNumber() + index}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.customerName}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.email}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.phone}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.partnerBankName}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.program}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{item.isSubmitedAt}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">

                                        <button onClick={() => openEditModal(item)}
                                            className="px-4 py-2 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white mr-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                                                <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                                <path fillRule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z" clipRule="evenodd" />
                                            </svg>


                                        </button>
                                        <button onClick={() => openEditV2PRMModal(item)}
                                            className="px-4 py-2 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                                                <path fillRule="evenodd" d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567h-1.843ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <nav className="flex justify-between">
                    <ul className="flex space-x-4 mt-5">
                        <li className={`prev ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}`}>
                            {currentPage === 1 ? <>   <a href="#" className='px-4 py-2 text-gray-700 border border-gray-300 rounded-md'>
                                &lt; previous
                            </a></> : <>
                                <a href="#" className='px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50' onClick={() => handlePageClick(currentPage - 1)}>
                                    &lt; previous
                                </a>
                            </>}
                        </li>
                        <li>
                            <div className='flex'>
                                {getPageNumbers().map((pageNumber) => (
                                    <button
                                        key={pageNumber}
                                        style={{ marginTop: '-8px' }}
                                        className={`px-4 py-2 mr-2 text-gray-700 border ${currentPage === pageNumber ? 'border-indigo-600' : 'border-gray-300'} rounded-md hover:bg-gray-50`}
                                    >
                                        {pageNumber}
                                    </button>
                                ))}
                            </div>
                        </li>

                        <li className={`next ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <a
                                href="#"
                                onClick={handleNextClick}
                                rel="customerList"
                                className="px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50"
                                disabled={currentPage === totalPages}
                            >
                                next &gt;
                            </a>
                        </li>
                    </ul>
                    <p className='mt-3'>
                        Page {currentPage} of {totalPages}, Total Records{' '}
                        {pendingData?.result.pagedInfo?.totalRecords || 0}
                    </p>
                </nav>
            </div >
        </>
    );
}

export default Pending;
